var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 128H256c-70.7 0-128 57.3-128 128v512c0 70.7 57.3 128 128 128h512c70.7 0 128-57.3 128-128V256c0-70.7-57.3-128-128-128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.16d90e9f4dfc4bfd4c49c115af2111f9.svg";
export { ForwardRef as ReactComponent };